import ReactDOM from 'react-dom'

import React, { Fragment, useState, useEffect, useCallback } from 'react'

import ModalContent from './ModalContent'

export default function Modal ({ children, afterHidden, ...props })
{
	const [trg, setTrg] = useState();
	const [visible, setVisible] = useState(props.open === true);

	useEffect(function ()
	{
		if (props.open === true && !visible) setVisible(true);

		if (props.trg && props.trg !== trg)
		{
			setTrg(props.trg);
		}
	},
	[props.open]);

	useEffect(function ()
	{
	// give back the focus to where it was before opening the modal
		if (!visible && trg && typeof trg.focus === 'function') trg.focus();

		if (!visible) setTrg(undefined);
	},
	[visible]);

	const handleAnimationEnd = useCallback(function ()
	{
		setVisible(props.open === true);

		if (typeof afterHidden === 'function') afterHidden();
	},
	[props.open, afterHidden]);

	const output =
	(
		<Fragment>
			{
				props.open || visible ?
				(
					<ModalContent onAnimationEnd={ handleAnimationEnd }
						open={ props.open === true }
						onClose={ props.onClose }
						footer={ props.footer }
						title={ props.title }
						bemit={ props.bemit }>
						{ children }
					</ModalContent>
				)
				: undefined
			}
		</Fragment>
	);

	return ReactDOM.createPortal(output, document.body);
}